import React, {Component} from 'react'
import timeHumanize from "../../../helpers/timeHumanize"
import ActionDelete from './ActionDelete'
import TableColumn from './TableColumn'
import {Input} from "reactstrap"
import PropTypes from "prop-types"

class TableRow extends Component {
    state = {
        loadingDelete: false,
        errorDelete: '',
    }

    _handleChangeSku = (e) => {
        const {onChangeSizes, item, index} = this.props
        const {name, value} = e.target

        const newItem = Object.assign(item, {[name]: value})

        onChangeSizes(newItem, index)
    }

    _handleChangeNumber = (e) => {
        const {onChangeSizes, item, index} = this.props
        const {name, value} = e.target

        const newItem = Object.assign(item, {[name]: parseFloat(value)})
        
        onChangeSizes(newItem, index)
    }

    _actionAddSize = () => {
        const {index, onAddSize} = this.props

        onAddSize(index)
    }

    _actionUpdateSize = () => {
        const {index, onUpdateSize} = this.props

        onUpdateSize(index)
    }
    
    _handlePasteNumber = (e) => {
        e.preventDefault()
        const {onPasteSizes, item, index} = this.props
        const {name, value} = e.target
        
        onPasteSizes(e, name, index)
    }

    render() {
        const {item, index, loadingItem, editingItem, isFFMView, isPasteRow, pastingItem} = this.props

        return <tr key={index}>
            <td><Input type='text' name="sku" value={item.sku} onChange={this._handleChangeSku} onPaste={this._handlePasteNumber}
                       style={{"width": "100%"}}/></td>
            <TableColumn onChangeInput={this._handleChangeNumber} onPasteInput={this._handlePasteNumber} name="height" value={item.height || 0}/>
            <TableColumn onChangeInput={this._handleChangeNumber} onPasteInput={this._handlePasteNumber} name="length" value={item.length || 0}/>
            <TableColumn onChangeInput={this._handleChangeNumber} onPasteInput={this._handlePasteNumber} name="width" value={item.width || 0}/>
            <td>{item.weight_by_v}</td>
            <TableColumn onChangeInput={this._handleChangeNumber} onPasteInput={this._handlePasteNumber} name="weight" value={item.weight || 0}/>
            <TableColumn onChangeInput={this._handleChangeNumber} onPasteInput={this._handlePasteNumber} name="additional_weight" value={item.additional_weight || 0}/>
            <TableColumn onChangeInput={this._handleChangeNumber} onPasteInput={this._handlePasteNumber} name="box_weight" value={item.box_weight || ''}/>
            <TableColumn onChangeInput={this._handleChangeNumber} onPasteInput={this._handlePasteNumber} name="full_size_weight" value={item.full_size_weight || ''}/>
            <td>{timeHumanize(item.updated_at || item.created_at)}</td>
            {isFFMView && <TableColumn onChangeInput={this._handleChangeNumber} onPasteInput={this._handlePasteNumber} name="base_cost" value={item.base_cost || 0}/>}
            <td className="text-center" colSpan={2}>
                {loadingItem === index ? (
                    <i className="icon-spinner2 spinner mr-1" />
                ) : (
                    <span>
                        {
                            (editingItem === index) || (isPasteRow && pastingItem === index) ?
                                <span>
                                    {
                                        item.type === 'add' ? (
                                            <i onClick={this._actionAddSize}
                                                className="icon-floppy-disk mr-1 text-primary" />
                                        ) : (
                                            <i onClick={this._actionUpdateSize}
                                                className="icon-floppy-disk mr-1 text-primary" />
                                        )
                                    }
                                </span>
                            : ''
                        }
                        {/* {
                            (isPasteRow && pastingItem === index) && <i onClick={this._actionUpdateSize}
                                className="icon-floppy-disk mr-1 text-primary" />
                        } */}
                        {item.type !== 'add' && (
                            <ActionDelete {...this.props} />
                        )}
                    </span>
                )}
            </td>
        </tr>
    }
}

TableRow.propTypes = {
    item: PropTypes.object.isRequired,
    index: PropTypes.number,
    loadingItem: PropTypes.number,
    editingItem: PropTypes.number,
    onAddSize: PropTypes.func.isRequired,
    onUpdateSize: PropTypes.func.isRequired,
    onChangeSizes: PropTypes.func.isRequired,
    onPasteSizes: PropTypes.func.isRequired,
}

export default TableRow